import React from "react";
import { AlertTriangle } from "lucide-react";

export const DISCLAIMER_TEXT =
  "All products are sold strictly for laboratory and research purposes only. Not for human consumption, personal use, or veterinary use.";

// Prominent, always-visible disclaimer band. Rendered on every page above the footer.
export const DisclaimerBar = () => (
  <div data-testid="global-disclaimer" className="w-full bg-[#E6DFD4] text-black">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-4 flex items-center justify-center gap-3 text-center">
      <AlertTriangle size={16} className="shrink-0" />
      <p className="text-[11px] sm:text-xs tracking-[0.12em] uppercase font-bold leading-snug">
        {DISCLAIMER_TEXT}
      </p>
    </div>
  </div>
);

export default DisclaimerBar;
